import { bannerInterface } from "@/components/Home/components/HomeIndex/moduleComponents/banners";
import { cardInterface } from "@/components/Home/components/HomeIndex/moduleComponents/Cards";
import { enterInterface } from "@/components/Home/components/HomeIndex/moduleComponents/Enterprises";
import { feedInterface } from "@/components/Home/components/HomeIndex/moduleComponents/FeedTab";
import { growsInterface } from "@/components/Home/components/HomeIndex/moduleComponents/Grows";
import { serviceInterface } from "@/components/Home/components/HomeIndex/moduleComponents/Service";
import {
  HotItem,
  weatherItem
} from "@/components/Home/components/HomeIndex/moduleComponents/weather";
import { janusInstance } from "@/components/Home/janus";
import { getCityCode } from "@/components/Home/utils";
export const getLayoutList = () => {
  return janusInstance.request({
    api: `appstore.getLayoutShow`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });
};
export const getWeather = () => {
  return janusInstance.request<weatherItem>({
    api: `calendar.getCurrentWeather`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });

  // return new Promise((res,rej)=>{
  //     rej(false)
  //     // res({
  //     //     "week": "周一",
  //     //     "date": "12/09",
  //     //     "districtName": "北京",
  //     //     "weather": "晴晴晴晴晴晴晴",
  //     //     "tempRange": "-14-26ºC"
  //     // })
  // })
};
export const getNewsData = () => {
  return janusInstance.request<HotItem>({
    api: `appstore.getTodayHotShow`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });

  // return new Promise((resolve)=>{
  //     resolve({
  //         "setting":{//模块信息
  //             "moduleName":"今日热点"
  //         },
  //         "content":{//热点信息
  //             "title":"北京政府：多维度推动专精特新“小巨人”企业持续扩容",
  //             "pcUrl":"pc端链接",
  //             "mobileUrl":"移动端链接"
  //         }
  //     })
  // })
};
export const getEnterpriseData = () => {
  return janusInstance.request<enterInterface>({
    api: `appstore.getEnterpriseShow`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });

  // return new Promise((resolve)=>{
  //     resolve({
  //         "enterpriseSetting":{
  //                        "moduleName":"一站式企业服务",
  //                        "description":"提供200+服务于企业全生命周期应用"
  //                               },
  //        "enterprises":[
  //            {
  //                "sort":1, //序号
  //                "title":"认资质质质", //内容标题
  //                "content":"企业资格认证与工商查询", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "applicationId":"XXXXXXX", //应用 id
  //                "serviceIconDisplay":1, //服务角标是否展示
  //                "serviceIconType":1, //服务角标类型 1热门推荐 2服务上新
  //                "iconUrl":"icon链接" //服务图标
  //            },
  //            {
  //              "sort":2, //序号
  //                "title":"推政策", //内容标题
  //                "content":"根据企业匹配政策", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "applicationId":"XXXXXXX", //应用 id
  //                "serviceIconDisplay":1, //服务角标是否展示
  //                "serviceIconType":1, //服务角标类型 1热门推荐 2服务上新
  //                "iconUrl":"icon链接" //服务图标
  //            },
  //            {
  //              "sort":2, //序号
  //                "title":"推政策", //内容标题
  //                "content":"根据企业匹配政策", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "applicationId":"XXXXXXX", //应用 id
  //                "serviceIconDisplay":1, //服务角标是否展示
  //                "serviceIconType":1, //服务角标类型 1热门推荐 2服务上新
  //                "iconUrl":"icon链接" //服务图标
  //            },
  //            {
  //              "sort":2, //序号
  //                "title":"推政策", //内容标题
  //                "content":"根据企业匹配政策", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "applicationId":"XXXXXXX", //应用 id
  //                "serviceIconDisplay":1, //服务角标是否展示
  //                "serviceIconType":1, //服务角标类型 1热门推荐 2服务上新
  //                "iconUrl":"icon链接" //服务图标
  //            }
  //        ]
  //    })
  // })
};
export const getDevelopmentPlan = () => {
  return janusInstance.request<growsInterface>({
    api: `appstore.getDevelopmentPlanShow`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });

  // return new Promise((res)=>{
  //      res({
  //         "setting":{//成长计划模块信息
  //             "moduleName":"京东企业/商家成长计划",
  //             "description":"为不同阶段企业提供全方位成长计划，包含线下运营服务",
  //             "pcurl":"pc跳转地址",
  //             "mobileUrl":"移动端链接"
  //         },
  //         "contentList":[//成长计划阶段
  //             {
  //                 "title":"创新中小",
  //                 "description":"7项服务",
  //                 "pcUrl":"pc端链接",
  //                 "mobileUrl":"移动端链接"
  //             },
  //             {
  //                 "title":"高新技术高新技术",
  //                 "description":"14项服务",
  //                 "pcUrl":"pc端链接",
  //                 "mobileUrl":"移动端链接"
  //             },
  //             {
  //                 "title":"高新技术链接",
  //                 "description":"14项服务",
  //                 "pcUrl":"pc端链接",
  //                 "mobileUrl":"移动端链接"
  //             },
  //             {
  //                 "title":"高新技术",
  //                 "description":"14项服务",
  //                 "pcUrl":"pc端链接",
  //                 "mobileUrl":"移动端链接"
  //             },
  //             {
  //                 "title":"高新技术",
  //                 "description":"14项服务",
  //                 "pcUrl":"pc端链接",
  //                 "mobileUrl":"移动端链接"
  //             }
  //         ]
  //     })
  // })
};

export const getCardsData = () => {
  return janusInstance.request<cardInterface>({
    api: `appstore.getOperationTileShow`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });

  // return new Promise((resolve)=>{
  //     resolve({
  //         "operationTileSetting":{
  //                        "lineNumber":1//展示行数
  //                               },
  //        "operationTiles":[
  //            {
  //                "sort":1, //序号
  //                "title":"高效办公", //内容标题
  //                "content":"邀请同事，一起高效工作", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "bg_image":'https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/app_jqt/bg.png',
  //                "mobileUrl":"移动端链接",
  //                "applicationId":"XXXXXXX", //应用 id
  //                "iconUrl":"icon链接" //服务图标
  //            },
  //            {
  //              "sort":2, //序号
  //                "title":"入驻京东", //内容标题
  //                "content":"成为商家，转化平台流量", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "bg_image":'https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/app_jqt/bg.png',
  //                "applicationId":"XXXXXXX", //应用 id
  //                "iconUrl":"icon链接" //服务图标
  //            },
  //            {
  //              "sort":2, //序号
  //                "title":"入驻京东", //内容标题
  //                "content":"成为商家，转化平台流量", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "bg_image":'https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/app_jqt/bg.png',
  //                "applicationId":"XXXXXXX", //应用 id
  //                "iconUrl":"icon链接" //服务图标
  //            },
  //            {
  //              "sort":2, //序号
  //                "title":"入驻京东", //内容标题
  //                "content":"成为商家，转化平台流量", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "bg_image":'https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/app_jqt/bg.png',
  //                "applicationId":"XXXXXXX", //应用 id
  //                "iconUrl":"icon链接" //服务图标
  //            },
  //            {
  //              "sort":2, //序号
  //                "title":"入驻京东", //内容标题
  //                "content":"成为商家，转化平台流量", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "bg_image":'https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/app_jqt/bg.png',
  //                "applicationId":"XXXXXXX", //应用 id
  //                "iconUrl":"icon链接" //服务图标
  //            },
  //            {
  //              "sort":2, //序号
  //                "title":"入驻京东", //内容标题
  //                "content":"成为商家，转化平台流量", //外显文案
  //                "urlType":1,//跳转链接类型；1：链接  2：应用
  //                "pcUrl":"pc端链接",
  //                "mobileUrl":"移动端链接",
  //                "bg_image":'https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/app_jqt/bg.png',
  //                "applicationId":"XXXXXXX", //应用 id
  //                "iconUrl":"icon链接" //服务图标
  //            }
  //        ]
  //    })
  // })
};

/**
 * @description: 获取常用服务
 * @return {*}
 */
export const getCommonService = () => {
  return janusInstance.request<serviceInterface>({
    api: `appstore.getConsumerCommonlyServerInfo`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });

  // return new Promise((resolve)=>{
  //     resolve({
  //         "settingDto": {
  //             "appColumn": 5,
  //             "title": "常用服务",
  //             "appRow": 2,
  //             "display": 1                 // 1 展示；0 不展示
  //         },
  //         "contentDtoList": [
  //             {
  //                 "cornerMarkerType": 1,     // 角标类型； 1 热门应用；2 服务上新
  //                 "cornerMarkerDisplay": 1,   //角标展示； 1 展示；0 不展示
  //                 "applicationBaseInfoList": [
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 0
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 1
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 2
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 3
  //                     },
  //                     {
  //                         "homeUrl": "/meeting",
  //                         "deploymentType": 1,
  //                         "deepLink": "/meeting",
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 4
  //                     },
  //                     {
  //                         "homeUrl": "/meeting",
  //                         "deploymentType": 1,
  //                         "deepLink": "/meeting",
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 5
  //                     },
  //                     {
  //                         "homeUrl": null,
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 6
  //                     }
  //                 ],
  //                 "iconUrl": "https://xtbg-lite-test.jdcloud.com/statics/imicon/yi24xAt5pomCb8Xgw1hD.png",
  //                 "position": 1,
  //                 "applicationId": "yi24xAt5pomCb8Xgw1hD",
  //                 "applicationName": "视频会议"
  //             },
  //             {
  //                 "cornerMarkerType": 2,
  //                 "cornerMarkerDisplay": 1,
  //                 "applicationBaseInfoList": [
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 0
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 1
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 2
  //                     },
  //                     {
  //                         "homeUrl": null,
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 3
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 4
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 5
  //                     },
  //                     {
  //                         "homeUrl": "/jdxtbglitetestet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 8
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 9
  //                     }
  //                 ],
  //                 "iconUrl": "https://xtbg-lite-test.jdcloud.com/eefs/download/114_20230804/QjL8aVwWagn0uLdRSKH9aYWpp.png?appKey=41d47591b3adf037",
  //                 "position": 2,
  //                 "applicationId": "PloJFyzbij4O26HXbjfX",
  //                 "applicationName": "智能会议"
  //             },
  //             {
  //                 "cornerMarkerType": 2,
  //                 "cornerMarkerDisplay": 0,
  //                 "applicationBaseInfoList": [
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 0
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 1
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 2
  //                     },
  //                     {
  //                         "homeUrl": null,
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 3
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 4
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 5
  //                     },
  //                     {
  //                         "homeUrl": "/jdxtbglitetestet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 8
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 9
  //                     }
  //                 ],
  //                 "iconUrl": "https://xtbg-lite-test.jdcloud.com/eefs/download/114_20230804/QjL8aVwWagn0uLdRSKH9aYWpp.png?appKey=41d47591b3adf037",
  //                 "position": 2,
  //                 "applicationId": "PloJFyzbij4O26HXbjfX",
  //                 "applicationName": "智能会议"
  //             },
  //             {
  //                 "cornerMarkerType": 2,
  //                 "cornerMarkerDisplay":0,
  //                 "applicationBaseInfoList": [
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 0
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 1
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 2
  //                     },
  //                     {
  //                         "homeUrl": null,
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 3
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 4
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 5
  //                     },
  //                     {
  //                         "homeUrl": "/jdxtbglitetestet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 8
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 9
  //                     }
  //                 ],
  //                 "iconUrl": "https://xtbg-lite-test.jdcloud.com/eefs/download/114_20230804/QjL8aVwWagn0uLdRSKH9aYWpp.png?appKey=41d47591b3adf037",
  //                 "position": 2,
  //                 "applicationId": "PloJFyzbij4O26HXbjfX",
  //                 "applicationName": "智能会议"
  //             },
  //             {
  //                 "cornerMarkerType": 2,
  //                 "cornerMarkerDisplay": 0,
  //                 "applicationBaseInfoList": [
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 0
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 1
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 2
  //                     },
  //                     {
  //                         "homeUrl": null,
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 3
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 4
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 5
  //                     },
  //                     {
  //                         "homeUrl": "/jdxtbglitetestet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 8
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 9
  //                     }
  //                 ],
  //                 "iconUrl": "https://xtbg-lite-test.jdcloud.com/eefs/download/114_20230804/QjL8aVwWagn0uLdRSKH9aYWpp.png?appKey=41d47591b3adf037",
  //                 "position": 2,
  //                 "applicationId": "PloJFyzbij4O26HXbjfX",
  //                 "applicationName": "智能会议"
  //             },
  //             {
  //                 "cornerMarkerType": 2,
  //                 "cornerMarkerDisplay": 0,
  //                 "applicationBaseInfoList": [
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 0
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 1
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 2
  //                     },
  //                     {
  //                         "homeUrl": null,
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 3
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 4
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 5
  //                     },
  //                     {
  //                         "homeUrl": "/jdxtbglitetestet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 8
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 9
  //                     }
  //                 ],
  //                 "iconUrl": "https://xtbg-lite-test.jdcloud.com/eefs/download/114_20230804/QjL8aVwWagn0uLdRSKH9aYWpp.png?appKey=41d47591b3adf037",
  //                 "position": 2,
  //                 "applicationId": "PloJFyzbij4O26HXbjfX",
  //                 "applicationName": "智能会议"
  //             },
  //             {
  //                 "cornerMarkerType": 2,
  //                 "cornerMarkerDisplay": 0,
  //                 "applicationBaseInfoList": [
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 0
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 1
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 2
  //                     },
  //                     {
  //                         "homeUrl": null,
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 3
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 4
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 5
  //                     },
  //                     {
  //                         "homeUrl": "/jdxtbglitetestet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 8
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 9
  //                     }
  //                 ],
  //                 "iconUrl": "https://xtbg-lite-test.jdcloud.com/eefs/download/114_20230804/QjL8aVwWagn0uLdRSKH9aYWpp.png?appKey=41d47591b3adf037",
  //                 "position": 2,
  //                 "applicationId": "PloJFyzbij4O26HXbjfX",
  //                 "applicationName": "智能会议"
  //             },
  //             {
  //                 "cornerMarkerType": 2,
  //                 "cornerMarkerDisplay": 0,
  //                 "applicationBaseInfoList": [
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 0
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 1
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 2
  //                     },
  //                     {
  //                         "homeUrl": null,
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 3
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 4
  //                     },
  //                     {
  //                         "homeUrl": "/jdmeet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 5
  //                     },
  //                     {
  //                         "homeUrl": "/jdxtbglitetestet",
  //                         "deploymentType": 1,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 8
  //                     },
  //                     {
  //                         "homeUrl": "http://www.jd.com",
  //                         "deploymentType": 5,
  //                         "deepLink": null,
  //                         "eGovHomeUrl": null,
  //                         "hostAppClient": 9
  //                     }
  //                 ],
  //                 "iconUrl": "https://xtbg-lite-test.jdcloud.com/eefs/download/114_20230804/QjL8aVwWagn0uLdRSKH9aYWpp.png?appKey=41d47591b3adf037",
  //                 "position": 2,
  //                 "applicationId": "PloJFyzbij4O26HXbjfX",
  //                 "applicationName": "智能会议"
  //             }
  //         ]
  //     })
  // })
};
/** 【首页】获取设置的banner*/
export const getBannerNew = () => {
  return janusInstance.request({
    api: `appstore.getConsumerBannerInfo`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });
};

export const getFeedTabList = () => {
  return janusInstance.request({
    api: `appstore.getFeedTabListShow`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });

  // return new Promise((resolve)=>{
  // resolve({

  //     "tabList":[
  //         {
  //             "tabName":"商机洞察",
  //             "tabUrl":"http://addf", //配置地址
  //             "sort":1 //排序
  //         },
  //         {
  //             "tabName":"最新政策",
  //             "tabUrl":"http://wef", //配置地址
  //             "sort":2 //排序
  //         },
  //         {
  //             "tabName":"知识产权",
  //             "tabUrl":"http://sdf", //配置地址
  //             "sort":3 //排序
  //         },
  //         {
  //             "tabName":"知识产权",
  //             "tabUrl":"http://sdf", //配置地址
  //             "sort":3 //排序
  //         },
  //         {
  //             "tabName":"知识产权",
  //             "tabUrl":"http://sdf", //配置地址
  //             "sort":3 //排序
  //         },
  //         {
  //             "tabName":"知识产权",
  //             "tabUrl":"http://sdf", //配置地址
  //             "sort":3 //排序
  //         },
  //         {
  //             "tabName":"知识产权",
  //             "tabUrl":"http://sdf", //配置地址
  //             "sort":3 //排序
  //         }
  //     ]
  //     })
  // })
};
/**
 * @description: 获取Feed流
 * @return {*}
 */
export const getFeedList = (pageNum: number, pageSize: number) => {
  return janusInstance.request<feedInterface>({
    method: "POST",
    api: "appstore.getFeedContentListShow",
    body: {
      pageNum,
      pageSize,
      cityCode: getCityCode()
    }
  });
};

/**
 * @description: 获取常用服务
 * @return {*}
 */
export const getBanner = () => {
  return janusInstance.request<bannerInterface>({
    api: `appstore.getConsumerBannerInfo`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });

  // return new Promise((resolve)=>{
  //     resolve({
  //         "errorCode": "0",
  //         "content": {
  //             "contentDtoList": [
  //                 {
  //                     "imgUrl": "https://jzb-test.jdcloud.com/eefs/res/download/20230321/4ToUFGNLEKYkoCELNirtGwtk5.jpeg?appKey=41d47591b3adf037",   //banner 图 url
  //                     "pcUrl": "https://www.baidu.com",        //pc 跳转 url
  //                     "applicationBaseInfoList": [],           //应用基础信息，当 linkType 为 2 时，需要从这里取跳转 url
  //                     "linkType": 1,                           //跳转链接类型；1：链接，取 mobileUrl或 pcUrl  ；  2：应用，取applicationBaseInfoList里的应用信息
  //                     "mobileUrl": "https://www.baidu.com",    //移动端跳转 url
  //                     "position": 1,                           //序号
  //                     "applicationId": "",                     //应用 id
  //                     "applicationName": ""                    //应用名称
  //                 },
  //                 {
  //                     "imgUrl": "https://jzb-test.jdcloud.com/eefs/res/download/100_20240513/SUaDMMwrAIqFpqqABIQoZ4HdC.png?appKey=3jlr7bx56nhitdb9",
  //                     "pcUrl": "",
  //                     "applicationBaseInfoList": [
  //                         {
  //                             "homeUrl": "http://www.jd.com",      //H5首页地址
  //                             "deploymentType": 5,          //开发类型  枚举见上面 逻辑同开放平台应用跳转
  //                             "deepLink": null,             //deeplink
  //                             "eGovHomeUrl": null,          //政务外网地址
  //                             "hostAppClient": 0            //宿主应用类型  枚举见上面 逻辑同开放平台应用跳转
  //                         },
  //                         {
  //                             "homeUrl": "http://www.jd.com",
  //                             "deploymentType": 5,
  //                             "deepLink": null,
  //                             "eGovHomeUrl": null,
  //                             "hostAppClient": 1
  //                         },
  //                         {
  //                             "homeUrl": "http://www.jd.com",
  //                             "deploymentType": 5,
  //                             "deepLink": null,
  //                             "eGovHomeUrl": null,
  //                             "hostAppClient": 2
  //                         },
  //                         {
  //                             "homeUrl": "http://www.jd.com",
  //                             "deploymentType": 5,
  //                             "deepLink": null,
  //                             "eGovHomeUrl": null,
  //                             "hostAppClient": 3
  //                         },
  //                         {
  //                             "homeUrl": "/meeting",
  //                             "deploymentType": 1,
  //                             "deepLink": "/meeting",
  //                             "eGovHomeUrl": null,
  //                             "hostAppClient": 4
  //                         },
  //                         {
  //                             "homeUrl": "/meeting",
  //                             "deploymentType": 1,
  //                             "deepLink": "/meeting",
  //                             "eGovHomeUrl": null,
  //                             "hostAppClient": 5
  //                         },
  //                         {
  //                             "homeUrl": null,
  //                             "deploymentType": 5,
  //                             "deepLink": null,
  //                             "eGovHomeUrl": null,
  //                             "hostAppClient": 6
  //                         }
  //                     ],
  //                     "linkType": 2,
  //                     "mobileUrl": "",
  //                     "position": 2,
  //                     "applicationId": "yi24xAt5pomCb8Xgw1hD",
  //                     "applicationName": "视频会议"
  //                 }
  //             ],
  //             "navigationDto": {
  //                 "searchDisplay": 1
  //             },
  //             "settingDto": {
  //                 "display": 1             //banner 是否显示；可以不使用，产品同步
  //             }
  //         },
  //         "errorMsg": "success"
  //     }
  //     )
  // })
};

/**
 * @description: 搜索企业服务
 * @return {*}
 */
export const searchService = (param: any) => {
  return janusInstance.request({
    api: `appstore.searchConsumerServiceTypeContent`,
    body: {
      ...param,
      cityCode: getCityCode()
    },
    method: "POST"
  });
};
/**
 * @description: 获取企业服务
 * @return {*}
 */
export const getServiceList = () => {
  return janusInstance.request({
    api: `appstore.getConsumerServiceTypeShow`,
    method: "POST",
    body: {
      cityCode: getCityCode()
    }
  });
};
